// Import React Library
import React, {useState, useEffect} from 'react';

// Import Components
import NavbarProducts from '../components/NavbarProducts';
import Cover from '../components/Cover';
import Footer from '../components/Footer';
import BreadcrumbsComponent from '../components/BreadcrumbsComponent';
import ProductGrid from '../components/products/ProductsGrid';
import WhatsappButton from '../components/WhatsappButton';

// Isopaneles Component
const Productos = () => {
    useEffect(() => {
        window.scrollTo(0, 0); 
    }, []);

    return (
        <>
            <NavbarProducts />
            <Cover section='productos' coverTitle='Productos' coverSubtitle='Isopaneles - Herramientas - Pisos - Estructuras - Aberturas'/>
            <WhatsappButton />
            <BreadcrumbsComponent currentSection='Productos'/>
            <ProductGrid categoria={'Isopaneles'} />
            <Footer />
        </>
    );
};

// Export Isopaneles Component
export default Productos;